<template>
  <div>
    <div class="source" >
      <el-row class="querypanel" style="padding: 30px;">
        <el-col :span="24">
          <el-form   label-width="120px" label-position="left" >
            <el-form-item label="行业名称:" >
              <el-input v-model="hyname" placeholder="请输入行业名称"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24">
          <div>
            <el-button style="margin-top: 10px; " @click="addmjgz">添加行业</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="querypanel">
        <el-col :span="24">
          <el-table
            stripe
            :data="hydata"
            ref="multipleTable">
            <el-table-column
              min-width="30px"
              prop="id.Int64"
              label="行业编号"
            >
            </el-table-column>
            <el-table-column
              prop="name.String"
              label="行业名称">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="移除该行业" placement="top-start">
                  <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removehy(scope.$index, hydata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'IndustriesMana',
  data () {
    return {
      hyname: '',
      hydata: [],
      khid: ''
    }
  },
  mounted: function () {
    that = this
    console.log(that)
    var v = getCookie('cusid')
    this.khid = v
    that = this
    that.$options.methods.queryhy()
  },
  methods: {
    addmjgz () {
      if (this.hyname !== '') {
        var idata = {
          name: {String: that.hyname, Valid: true},
          parentid: parseInt(-1),
          level: parseInt(1),
          haschild: parseInt(0)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/aaubii',
          method: 'post',
          data: idata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var objtmp = JSON.parse(res.data.data)
              console.log(objtmp)
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
              that.$options.methods.queryhy()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    removehy (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/dbii',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryhy () {
      var qstr = 'id>0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/gbii',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            var objtmp = JSON.parse(res.data.data)
            console.log(objtmp)
            that.hydata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/cus/IndustriesMana.vue